import clsx from "clsx"
import { useId } from "react"

export const formClasses =
    "block w-full appearance-none rounded-md border border-gray-400 px-3 py-2 text-gray-900 placeholder-gray-400 focus:border-primary-500 focus:bg-white focus:outline-none focus:ring-primary-500 sm:text-sm"

function Label({ id, children }: { id: string; children: React.ReactNode }) {
    return (
        <label htmlFor={id} className="mb-3 block text-sm font-medium text-gray-700">
            {children}
        </label>
    )
}

export function TextField({
    label,
    type = "text",
    className,
    ...props
}: Omit<React.ComponentPropsWithoutRef<"input">, "id"> & { label: string }) {
    const id = useId()

    return (
        <div className={className}>
            {label && <Label id={id}>{label}</Label>}
            <input id={id} type={type} {...props} className={formClasses} />
        </div>
    )
}

export function NumberField({
    label,
    type = "number",
    className,
    ...props
}: Omit<React.ComponentPropsWithoutRef<"input">, "id"> & { label: string }) {
    const id = useId()

    return (
        <div className={className}>
            {label && <Label id={id}>{label}</Label>}
            <input id={id} type={type} {...props} className={formClasses} />
        </div>
    )
}

export function SelectField({
    label,
    className,
    ...props
}: Omit<React.ComponentPropsWithoutRef<"select">, "id"> & { label: string }) {
    const id = useId()

    return (
        <div className={className}>
            {label && <Label id={id}>{label}</Label>}
            <select id={id} {...props} className={clsx(formClasses, "pr-8")} />
        </div>
    )
}
